{
  "a11y": {
    "skipToContent": "Gå til hovedinnhold",
    "clipboardNoAccess": "Vi har ikke tilgang til utklippstavlen, så vi kan ikke kopiere mappinger."
  },
  "breadcrumbs": {
    "/": "Hjem",
    "unauthorized": "Ingen tilgang",
    "agreements": "Avtaler",
    "agreements-id": "Avtale",
    "accounting-rules": "Konteringsregler",
    "accounting-rules-id": "Konteringsregel",
    "accounting-months": "Regnskapsmåneder",
    "accounting-months-id": "Regnskapsmåned",
    "id": "{id}",
    "settlements": "Oppgjør",
    "settlements-id": "Oppgjør",
    "correction-of-settlements": "Korreksjonsoppgjør",
    "settlement-import": "Testavregning",
    "sales-transaction-summaries": "Sales transaction summary",
    "incoming-settlements": "Innkommende oppgjør",
    "incoming-settlements-id": "Innkommende oppgjør",
    "settlement-no-id": "Kassaoppgjør",
    "point-of-sale": "Kassapunkter",
    "point-of-sale-id": "Kassapunkt",
    "new": "Opprett ny",
    "dist-channels": "Distribusjonskanaler",
    "dist-channels-id": "Distribusjonskanal",
    "incoming-annexes": "Innkommende underbilag",
    "agreement-mappings": "Avtalemappinger",
    "accounting-mappings": "Konteringsmappinger",
    "mappings-id": "Mapping",
    "accounting-mappings-id": "Konteringsmapping",
    "clearing-mappings": "Avregningsmappinger",
    "clearing-mappings-id": "Avregningsmapping",
    "line": "Linje",
    "lines": "Linjer",
    "lines-id": "Linje",
    "settlement-sign-off": "Kvitter",
    "charts-of-accounts": "Kontoplaner",
    "charts-of-accounts-id": "Kontoplan",
    "segment1": "Organisasjoner",
    "segment1-id": "Organisasjon",
    "segment2": "Ansvarssteder",
    "segment2-id": "Ansvarssted",
    "segment3": "Konto",
    "segment3-id": "Konto",
    "segment4": "Aktiviteter",
    "segment4-id": "Aktivitet",
    "segment5": "Prosjekter",
    "segment5-id": "Prosjekt",
    "segment6": "Speskoder",
    "segment6-id": "Speskode",
    "segment7": "MVA koder",
    "segment7-id": "MVA kode",
    "operating-messages": "Driftsmeldinger",
    "operating-messages-id": "Driftsmelding",
    "report-search": "Rapportsøk",
    "new-template": "Ny rapportmal",
    "report-templates": "Rapportmaler",
    "report-templates-id": "Rapportmal",
    "report-statistics": "Rapportstatistikk",
    "data-products": "Dataprodukter",
    "data-products-id": "Dataprodukt",
    "callback": "Ukjent",
    "versions": "Versjoner",
    "update-template": "Oppdater",
    "template": "Mal",
    "users": "Brukere",
    "users-id": "Bruker",
    "groups": "Grupper",
    "groups-id": "Gruppe",
    "undefined": "Ukjent",
    "xledger": "XLedger overføringer",
    "xledger-id": "XLedger",
    "audit-log": "Auditlog",
    "audit-log-id": "Auditlog",
    "settlement-bcc": "BCC Oppgjør",
    "settled-data": "Avregnede data",
    "manual-refs": "Ref",
    "manual-refs-id": "Ref",
    "correction-id": "Korriger",
    "generic-transaction-imports-id": "Generisk underbilag",
    "correction-of-settlement": "Korreksjonsoppgjør",
    "manual-settlement": "Manuelt oppgjør",
    "sales-transaction-summaries-id": "Salgspakke",
    "sales-transaction-summary-imports-id": "Salgspakke",
    "sales-payments-id": "Betaling",
    "sales-payment-imports-id": "Betaling",
    "sales-credit-imports-id": "Kreditering",
    "sales-credits-id": "Kreditering",
    "sales-difference-imports-id": "Differanse",
    "sales-differences-id": "Differanse",
    "sales-deposit-imports-id": "Deponering",
    "sales-deposits-id": "Deponering",
    "sales-manual-line-imports-id": "Manuell linje",
    "sales-manual-lines-id": "Manuell linje",
    "partners": "Partnere",
    "partners-id": "Partner",
    "generic-transactions-id": "Generisk underbilag",
    "transaction-types": "Transaksjonstyper",
    "transaction-types-id": "Transaksjonstype",
    "annex-clearing-result": "Testavregne underbilag"
  },
  "menu": {
    "reports": "Rapporter",
    "reportSearch": "Rapportsøk",
    "reportTemplates": "Rapportmaler",
    "reportProduction": "Rapportkjøring",
    "reportStatistics": "Rapportstatistikk",
    "failedReports": "Feilede rapporter",
    "dataProducts": "Dataprodukter",
    "incoming-settlements": "Innkommende oppgjør",
    "settlements": "Oppgjør",
    "settled-data": "Avregnede data",
    "settlementSearch": "Oppgjørssøk",
    "clearing": "Avregning",
    "agreements": "Avtaler",
    "accounting-mappings": "Konteringsmappinger",
    "clearingMappings": "Avregningsmappinger",
    "search": "Søk",
    "settlement-sign-off": "Kvitter",
    "register": "Register",
    "pos-registry": "Kassapunkter",
    "dist-channels": "Distribusjonskanaler",
    "admin": "Admin",
    "accountingMonth": "Regnskapsmåneder",
    "users": "Brukere",
    "groups": "Grupper",
    "companys": "Selskaper",
    "organisations": "Organisasjoner",
    "agreement-mappings": "Avtalemappinger",
    "chartOfAccounts": "Kontoplan",
    "segment1": "Organisasjoner",
    "segment2": "Ansvarssteder",
    "segment3": "Kontoer",
    "segment4": "Aktiviteter",
    "segment5": "Prosjekter",
    "segment6": "Speskoder",
    "segment7": "MVA koder",
    "incoming-annexes": "Innkommende underbilag",
    "settlement-bcc": "BCC oppgjør",
    "operatingMessages": "Driftsmeldinger",
    "accountingRules": "Konteringsregler",
    "lines": "Linjer",
    "cleosTabTitle": " | CLEOS",
    "help": "Hjelp",
    "keyNavigation": "Tastaturnavigasjon",
    "shortcuts": "Tastatursnarveier",
    "surveillance": "Overvåkning",
    "xledger": "XLedger",
    "settings": "Innstillinger",
    "audit-log": "Auditlog",
    "manual-refs": "Navn på ref",
    "partners": "Partnere",
    "manual-settlement": "Manuelt oppgjør",
    "logout": "Logg ut",
    "userMenu": "Brukermeny",
    "mainMenu": "Hovedmeny",
    "openSidebar": "Åpne sidemeny",
    "closeSidebar": "Lukk sidemeny",
    "annex-clearing-results": "Testavregning underbilag",
    "chartOfAccountsError": "Fant ingen kontoplaner"
  },
  "chips": {
    "id": "Id",
    "agreementName": "Avtale\u200Bnavn",
    "agreementId": "Avtale Id",
    "companycode": "Selskaps\u200Bkode",
    "companyCode": "Selskaps\u200Bkode",
    "mappingName": "Avregn.\u200Bmapping\u200Bnavn",
    "posRef": "POS Ref",
    "pointOfSaleRef": "POS Ref",
    "settlementNo": "Oppgjørs\u200Bnr",
    "correctedSettlementNo": "Korr. oppgj.nr",
    "settlementDate": "Oppgjørs\u200Bdato",
    "originalSettlementDate": "Original oppgjørs\u200Bdato",
    "msgDistributionChannel": "Distri\u200Bbusjons\u200Bkanal",
    "distributionChannelRef": "Distri\u200Bbusjons\u200Bkanal",
    "organisationRef": "Organis\u200Basjons Ref",
    "importStatus": "Status",
    "externalSettlementNo": "Ekst. oppgj.nr",
    "signOff": "Mottatt av",
    "qrCode": "QR kode",
    "name": "Navn",
    "code": "Kode",
    "status": "Status",
    "lineRef": "Linje ref",
    "organisationId": "Organis\u200Basjon Id",
    "title": "Tit\u200Btel",
    "createdBy": "Oppret\u200Btet av",
    "fromDate": "F.o.m",
    "toDate": "T.o.m",
    "userid": "Brukernavn",
    "createdDate": "Dato opprettet",
    "group": "Gruppe",
    "companyName": "Navn",
    "candidateFilterString": "Kandidat\u200Bfilter",
    "ruleName": "Konterings\u200Bregel\u200Bnavn",
    "reportId": "Rapport Id",
    "standardCode": "Standard MVA kode",
    "localTaxCode": "Lokal MVA kode",
    "localName": "MVA Navn",
    "batchId": "Batch Id",
    "templateId": "Mal Id",
    "transferCompleted": "Fullført",
    "userId": "Bruker\u200Bnavn",
    "timestamp": "Utført dato",
    "privilege": "Rettighet",
    "lastActiveDate": "Sist pålogget dato",
    "posCreationMode": "Automatisk POS",
    "version": "Versjon",
    "cleosFilename": "Filnavn",
    "orderDateTime": "Bestill​ings​dato",
    "orgNumber": "Organisasjons-/\u200Bkundenr",
    "agreementType": "Avtale\u200Btype",
    "agreementRef": "Avtale\u200Bref",
    "deliverSalesdescription": "Salgsbeskrivelse",
    "reportType": "Format"
  },
  "startpage": {
    "welcome": "Velkommen"
  },
  "versionsPage": {
    "environment": "Miljø",
    "development": "Lokal",
    "dev": "Dev",
    "staging": "Staging",
    "production": "Produksjon",
    "cleosClient": "CLEOS client",
    "cleosServices": "CLEOS services",
    "cleosReporting": "CLEOS reporting",
    "cleosXledger": "CLEOS xledger",
    "cleosEss": "CLEOS ESS integration",
    "dockerImage": "Docker image",
    "versions": "Versjoner",
    "noImage": "Ingen",
    "Ingen": "Ingen"
  },
  "profilePage": {
    "myProfile": "Min profil",
    "enturUser": "Entur bruker",
    "permissions": "Tilganger",
    "settings": "Innstillinger",
    "noSettingsAvailable": "Ingen innstillinger tilgjengelig",
    "chartOfAccountsFilter": "Filtrering på kontoplan",
    "defaultChartOfAccounts": "Standard kontoplan",
    "colorMode": "Fargetema",
    "colorModes": {
      "system": "Systeminnstillinger",
      "light": "Lyst",
      "ultralight": "Ultralyst",
      "dark": "Mørkt"
    },
    "featureFlags": "Funksjoner under utvikling",
    "featureFlagsDescription": "Slå på funksjoner som ikke er ferdige ennå. Valget gjelder bare for deg i denne nettleseren.",
    "featureFlagNames": {
      "cashRegisterSettlements": "Kassaoppgjør i oppgjørssøk",
      "uniformen": "Ny felles toppmeny (Uniformen)"
    }
  },
  "generalValues": {
    "id": "Id",
    "cleos": "CLEOS",
    "close": "Lukk",
    "closed": "Lukket",
    "delete": "Slett",
    "dateCreated": "Dato opprettet",
    "link": "Link",
    "attachments": "Vedlegg",
    "externalComments": "Eksterne kommentarer",
    "loading": "Laster...",
    "fetchingX": "Henter {data}",
    "fetchingData": "Henter data...",
    "sortedBy": "Sortert på",
    "filterBy": "Filtrer på",
    "emptyForm": "Tøm skjema",
    "search": "Søk",
    "noChosenValue": "Ingen valgt",
    "tryAgain": "Prøv igjen",
    "selectCompanyToCreateX": "Velg organisasjon for å opprette {type}",
    "showDetails": "Vis detaljer",
    "noResultBasedOnInput": "Verdiene du har skrevet inn ga ingen treff. Vennligst endre en eller flere av verdiene og forsøk igjen.",
    "drawerInfo": "Klikk på en {data} i listen for mer info.",
    "displayMode": "Du er nå i visnings\u200Bmodus",
    "editMode": "Du er nå i redigerings\u200Bmodus",
    "copyMode": "Du er nå i kopierings\u200Bmodus",
    "createMode": "Du er nå i opprett\u200Bmodus",
    "editX": "Rediger {value}",
    "edit": "Rediger",
    "copyX": "Kopier {value}",
    "yes": "ja",
    "no": "nei",
    "yes2": "Ja",
    "no2": "Nei",
    "pleaseChoose": "Vennligst velg",
    "cancel": "Avbryt",
    "save": "Lagre",
    "create": "Opprett",
    "created": "Opprettet",
    "createNew": "Opprett ny",
    "update": "Oppdater",
    "fromInclDate": "F.o.m",
    "toInclDate": "T.o.m",
    "OutgoingCashHoldings": "Utgående kontantbeholdning",
    "IncomingCashHoldings": "Innkommende kontantbeholdning",
    "type": "Type",
    "alternativeChosen": "Alt\u200Bernativ valgt",
    "alternativesChosen": "Alt\u200Bernativer valgt",
    "version": "Versjon",
    "json": "JSON",
    "showJson": "Vis JSON...",
    "next": "Neste",
    "import": "Importer",
    "importCLEOS": "Importer via CLEOS",
    "unknown": "Ukjent",
    "download": "Last ned",
    "all": "Alle",
    "daily": "Daglig",
    "weekly": "Ukentlig",
    "monthly": "Månedlig",
    "deliverWeekly": "Leveres uke\u200Bntlig",
    "status": "Status",
    "statusActive": "Aktiv",
    "statusPaused": "Pauset",
    "statusLocked": "Låst",
    "statusDiscontinued": "Avviklet",
    "name": "Navn",
    "code": "Kode",
    "lastUpdated": "Sist oppdatert",
    "title": "Tittel",
    "deleteHeading": "Slette {type}?",
    "deleteText": "Er du sikker på at du vil slette {type} {name}?",
    "deleteOk": "Ja, slett {type}",
    "deleteConditionsHeading": "Betingelser for sletting",
    "defaultDeleteConditions": "Ingen betingelser.",
    "noOptions": "Ingen treff",
    "sum": "Sum",
    "cannotBeSmaller": "Til dato kan ikke være mindre enn fradato",
    "emptyList": "Tom liste",
    "comments": "Komment\u200Barer",
    "comment": "Kommentar",
    "addComment": "Legg til kommentar",
    "total": "Total",
    "paymentTypes": "Betalingstype",
    "orderVersion": "Ordre:\u200BVersjon",
    "description": "Beskrivelse",
    "chosenValue": "Valgt verdi:",
    "showDiscontinued": "Vis avviklede {data}",
    "userid": "Brukernavn",
    "posCreationMode": "Automatisk POS",
    "posManual": "Manuell",
    "posActive": "Aktiv",
    "posPaused": "Pauset",
    "fetchingUser": "Henter bruker...",
    "fileToBig": "Filen er for stor, max størelse er 10 MB",
    "copy": "Kopiér",
    "use": "Bruk",
    "remove": "Fjern",
    "maxFileSizeAndType": " Max 10 MB | Godkjente Filtyper: .zip .jpg .jpeg .png .pdf .rtf .txt .doc .docx .odt .xls .xlsx .ods .ppt .pptx .odt",
    "attributes": "Attributter",
    "context": "Kontekst",
    "foreignAmount": "F.valuta",
    "atleast3Characters": "Minst tre tegn",
    "fraction": "Fraction",
    "functionCalculations": "Funksjonsberegninger",
    "selectAll": "(Velg alle)",
    "noValue": "Ingen verdi",
    "reset": "Nullstill",
    "of": "av",
    "rows": "rader",
    "selected": "valgte",
    "copyToClip": "Kopier",
    "expand": "Ekspander",
    "collaps": "Kollaps",
    "deleteCorrectionsText": "Er du sikker på at du vil forkaste dine endringer?",
    "deleteCorrectionsHeader": "Forkast endringer?",
    "deleteCorrectionText": "Er du sikker på at du vil slette denne korreksjonen?",
    "deleteCorrectionHeader": "Slette korreksjon?",
    "owner": "Eier",
    "noChartsOfAccounts": "Finner ikke kontoplan",
    "lastUpdatedAt": "Søkeresultat oppdatert: {date}"
  },
  "accountingFlow": {
    "order": "Ordre",
    "noOrder": "(uten ordre)",
    "product": "Produkt",
    "noProduct": "(uten produkt)",
    "productless": {
      "SALES_PAYMENT": "(betaling)",
      "SALES_CREDIT": "(kreditering)",
      "SETTLEMENT": "(oppgjør)",
      "JUSTERING": "(justering)",
      "BCC": "(BCC)"
    },
    "chart": "Kontoplan",
    "agreement": "Avtale",
    "clearingType": "Allokeringstype",
    "mapping": "Avregningsmapping",
    "noMapping": "(uten mapping)",
    "rule": "Konteringsregel",
    "account": "Konto",
    "segment2": "Ansvarssted",
    "segment4": "Aktivitet",
    "segment5": "Prosjekt",
    "segment6": "Speskode",
    "segment7": "MVA-kode",
    "segments": "Segment 2–7",
    "debit": "+Debet",
    "credit": "+Kredit",
    "noDetails": "Ingen detaljer for en samlet node",
    "partialPage": "Flytdiagrammet viser linjene på denne siden ({shown} av {total}). Velg flere per side, opptil 1000, for å se mer."
  },
  "resultView": {
    "label": "Visning",
    "table": "Tabell",
    "tAccount": "T-konto",
    "flow": "Flyt"
  },
  "toastAlerts": {
    "saved": "Lagret.",
    "added": "Opprettet.",
    "updated": "Oppdatert.",
    "updatedX": "Oppdatert {value}.",
    "deleted": "Slettet.",
    "copied": "Kopiert.",
    "noValidData": "Dataene du har kopiert er ikke gyldige.",
    "pasteInEnv": "Importer til ønsket miljø.",
    "exported": "Eksportert.",
    "pasted": "Importerer mapping fra: ",
    "pasteSource": "Kilde: {data}",
    "orderReport": "Rapportene er bestilt og produseres ved anledning.",
    "errorCopy": "Feil ved kopiering. Prøv igjen.",
    "errorCopyPermission": "Feil ved kopiering. Nettleseren har ikke tilgang til å kopiere",
    "failedTryAgain": "Noe feilet, prøv på nytt.",
    "delayOfCharts": "Det kan ta opptil 1 minutt før kontoplantilganger er oppdatert."
  },
  "agreements": {
    "type": "Avtale",
    "typePlural": "Avtaler",
    "name": "Avtale\u200Bnavn",
    "id": "Avtale Id",
    "create": "Opprett avtale",
    "showMapping": "Vis avtaler uten aktive mappinger",
    "searchMappings": "Søk Avregningsmappinger",
    "agreementSearch": "Avtalenavn/\u200BId",
    "orgCustomerNumber": "Organisasjons-/\u200Bkundenr",
    "deliverTo": "Avtale\u200Btype",
    "agreementRef": "Avtale\u200Breferanse",
    "agreementId": "Avtale (avtale Id)",
    "agreementParty": "Avtale\u200Bpart",
    "address": "Adresse",
    "email": "E-post",
    "invoiceText": "Fri\u200Btekst",
    "delivery": "Leverer til",
    "deliverSalesDescription": "Lever salgs\u200Boppgave (legacy)",
    "bankAccount": "Bankkonto",
    "showVATOnAnnex": "Vis MVA på avregnings\u200Bbilag",
    "addressRef": "Adresse\u200Breferanse",
    "customerRef": "Kunde\u200Breferanse",
    "overrideTaxCode": "Overstyr standard MVA kode fra",
    "agreementHasActiveMappings": "Avtalen kan ikke avvikles med aktive mappinger",
    "noActiveMappings": "Avtalen har ingen aktive mappinger, for å se pausede og avviklede mappinger på avtalen, søk etter disse ved å klikke ‘Søk Mappinger‘",
    "orderReportOwner": "Rapporter til bokføringspartner",
    "chooseOrderReportOwner": "Velg rapporter til bokføringspartner",
    "orderReportParty": "Rapporter til rapporteringspartner/\u200Bmaleier",
    "chooseOrderReportParty": "Velg rapporter til rapporteringspartner/\u200Bmaleier",
    "dataProducts": "Dataprodukter",
    "activeAgreements": "Aktive Avtaler",
    "accountingPartner": "Bokføringspartner",
    "reportingPartner": "Rapporteringspartner (legacy)",
    "reportingPartnerInfo": "Feltet gjelder kun for konfigurering av legacy rapporter og vil fjernes i fremtiden.",
    "grantAccessTitle": "Gi tilgang til kontoplan",
    "grantAccessContent": "Vil du gi partner {partner} tilgang til kontoplan {chartOfAccounts}?",
    "grantAccessButton": "Gi tilgang",
    "agreementDropdownError": "Kunne ikke hente avtaler.",
    "deleteRow": "Slett rad",
    "batchFrequency": "AP/AR rapporteringsfrekvens",
    "externalReference": "Ekstern referanse"
  },
  "clearingMappings": {
    "type": "Avregnings\u200Bmapping",
    "typePlural": "Avregningsmappinger",
    "mappingSmall": "avregningsmapping",
    "create": "Opprett Avregningsmapping",
    "mappingNameId": "Avregnings\u200Bmapping\u200Bnavn/\u200BId",
    "mappingId": "Avregningsmapping Id",
    "mappingIdShort": "Avr.mapping Id",
    "candidateFilterString": "Kandidatfilter",
    "candidateFilterCopied": "Kandidat\u200Bfilter kopiert",
    "candidateSet": "Kandidat\u200Bsett",
    "acctCandidateSetAdditions": "Utvidet kandidatsett for konteringsmapping",
    "mappingName": "Avregnings\u200Bmapping\u200Bnavn",
    "agreementId": "Avtale (avtale Id)",
    "accountingRuleShort": "Kont.reg.",
    "mappingInUse": "Mapping er i bruk",
    "accountingType": "Type",
    "formula": "Formel",
    "factor": "Faktor",
    "comission": "Provi\u200Bsjon",
    "needSignOff": "Må kvit\u200Bteres",
    "net": "Netto",
    "netDiff": "Netto\u200Bdiff",
    "percent": "Prosent",
    "proportionalOnAmount": "Propor\u200Bsjonalt på beløp",
    "proportionalOnPeriod": "Propor\u200Bsjonalt på periode",
    "proportionalOnOperationPeriod": "Driftsdøgn proporsjonalt på periode",
    "proportionalOnWeight": "Propor\u200Bsjonalt på vekt",
    "fixedFee": "Fast\u200Bpris",
    "deleteMapping": "Slett avregningsmapping...",
    "price": "Pris",
    "priceContribution": "Pris\u200Bbidrag",
    "primary": "Peker",
    "notExists": "Ikke lik",
    "alternativeOwnerFilterString": "Andels\u200Beier\u200Bfilter",
    "overrideTaxCode": "Overstyr MVA kode",
    "copyToClip": "Kopier",
    "activeMappings": "Aktive Avregningsmappinger",
    "accountingMappingEnabled": "Kan brukes til konteringsmapping",
    "export": "Eksporter",
    "manualMapping": "Kan brukes til manuelle oppgjør",
    "mappingNameInfoText": "Søk på REF, eller skriv inn ønsket navn direkte.",
    "mappingFunction": "Mappingfunksjoner",
    "chooseMappingFunctions": "Velg mappingfunksjoner",
    "mappingFunctionDropdownError": "Kunne ikke hente mappingfunksjoner",
    "deleteConditions": "Avregningsmappingen har startdato i denne måneden eller senere, og er så langt ikke brukt i avregning.",
    "signOff": "Kvittering",
    "clearingTransType": "Avregningstype",
    "clearingType": "Variant",
    "factorInvalidNumber": "Faktor må være et tall",
    "factorMax4Decimals": "Faktor kan ikke ha mer enn 4 desimaler",
    "factorBelowMinValue": "Faktor må være større enn -100000000",
    "factorAboveMaxValue": "Faktor må være mindre enn 100000000",
    "editMappings": "Rediger {value} mappinger",
    "mappings": "mappinger",
    "containsInvalidMappingX": "Følgende mappinger mangler til dato: {data}",
    "transactionType": "Transaksjons\u200Btype"
  },
  "accountingMappings": {
    "type": "Konterings\u200Bmapping",
    "typePlural": "Konterings\u200Bmappinger",
    "create": "Opprett Konteringsmapping",
    "mappingName": "Mapping\u200Bnavn",
    "mappingIdShort": "Kont.mapping Id",
    "mappingNameId": "Konterings\u200Bmapping\u200Bnavn/\u200BId",
    "candidateFilterString": "Kandidat\u200Bfilter",
    "deleteMapping": "Slett konteringsmapping",
    "mappingSmall": "konteringsmapping",
    "deleteConditions": "Konteringsmapingen har startdato i denne måneden eller senere, og er så langt ikke brukt i avregning.",
    "tagPlaceholder": "Skriv inn verdier som en kommaseparert liste (f.eks. element1, element2, element3).",
    "activeMappings": "Aktive Konteringsmappinger",
    "orderReportOwner": "Rapporter til bokføringspartner",
    "chooseOrderReportOwner": "Velg rapporter til bokføringspartner",
    "orderReportParty": "Rapporter til maleier",
    "chooseOrderReportParty": "Velg rapporter til maleier"
  },
  "accountingrules": {
    "accountingRuleId": "Konterings\u200Bregel Id",
    "accountingRuleIdS": "Kont.regel Id",
    "type": "Konterings\u200Bregel",
    "typePlural": "Konterings\u200Bregler",
    "companyAccountingRule": "Velg selskap for å opprette konterings\u200Bregel",
    "createAccountingRule": "Opprett konterings\u200Bregel",
    "ruleName": "Konterings\u200Bregel\u200Bnavn",
    "accountingRuleLine": "Konterings\u200Bregel\u200Blinje",
    "newLine": "Ny linje",
    "accountingDate": "Bokførings\u200Bdato",
    "debitCredit": "Debet/\u200BKredit",
    "factorPercent": "Faktor (%)",
    "accountingRuleSearch": "Konteringsregelnavn/Id",
    "noActiveMappings": "Ingen aktive mappinger på denne konteringsregelen.",
    "activeAccountingRules": "Aktive Konteringsregler",
    "factorInvalidNumber": "Faktor må være et tall eller verdien '$TAXRATE'",
    "factorMax4Decimals": "Faktor kan ikke ha mer enn 4 desimaler",
    "factorRange": "Faktor må være mellom 0 og 100",
    "lines": "Konteringsregellinjer",
    "deleteLineHeader": "Slette konteringsregellinje?",
    "deleteLineText": "Er du sikker på at du vil slette denne konteringsregellinjen?",
    "segment7StandardId": "Std MVA-kode",
    "segment7LocalId": "Lokal MVA-kode+rate",
    "segment7Placeholder": "Bruk innkommende",
    "dropdownError": "Kunne ikke hente konteringsregler."
  },
  "accountingLinesPosted": {
    "typePlural": "Avregnede data",
    "settlementId": "Oppgjør Id",
    "searchSmtId": "Oppgjør Id",
    "searchOrderId": "Ordre Id",
    "searchMappingId": "Avregningsmapping Id",
    "tabSearchMappingId": "Avr.mapping Id",
    "searchAgreement": "Avtale",
    "searchAccountingMonth": "Regnskapsmåned",
    "clearingMonth": "Avregningsmåned",
    "searchSettledData": "Søk avregnede data",
    "noDataBefore": "Her finner du avregnede data etter 01. mai 2022.",
    "futureMonths": "FREMTIDIGE måneder"
  },
  "settlementSearch": {
    "type": "Oppgjørs\u200Bsøk",
    "rrnr": "RRNR",
    "rrnr6": "RRNR (min. 6 siste siffer)",
    "orderId": "Ordre Id",
    "settlementNoL": "Opp\u200Bgjørs\u200Bnummer",
    "settlementNoM": "Opp\u200Bgjørs\u200Bnr",
    "settlementNoS": "Oppgj.nr",
    "externalSettlementNoL": "Ekst\u200Bernt oppgjørs\u200Bnummer",
    "externalSettlementNoM": "Ekst. oppgjørs\u200Bnr",
    "externalSettlementNoS": "Ekst. oppgj.nr",
    "correctedSettlementNoL": "Korr\u200Bigerer oppgjørs\u200Bnummer",
    "correctedSettlementNoM": "Korr. oppgjørs\u200Bnr",
    "correctedSettlementNoS": "Korr. oppgj.nr",
    "correctedSettlement": "Korrigerer oppgjør",
    "nr": "Nr.",
    "noDate": "Ingen dato",
    "date": "Dato",
    "boxNumber": "Boksnummer",
    "externalReference": "Eksternreferanse",
    "originalSettlementDate": "Original oppgjørs\u200Bdato",
    "originalSettlementDateSmall": "Orig. dato",
    "receivedBy": "Mottatt av",
    "settlementDate": "Oppgjørs\u200Bdato",
    "settlementDateSmall": "Oppgj.\u200Bdato",
    "linkToPartnerText": "Vis i Entur Partner",
    "settlementAgent": "Oppgjørs\u200Bagent",
    "cashRegisterSettlement": "Kassa\u200Boppgjør",
    "tooManySettlements": "Søket gir {total} bilag, og bare de {shown} første er tatt med. Avgrens søket for å få komplette kassaoppgjør."
  },
  "cashRegisterSettlement": {
    "type": "Kassa\u200Boppgjør",
    "numberOfSettlements": "Antall bilag",
    "settlements": "Samlebilag i oppgjøret",
    "settlement": "Samlebilag",
    "annexes": "Bilagsdokumenter",
    "annexesLimit": "Bilagsdokumentene vises samlet for oppgjør med opptil {max} samlebilag. Dette oppgjøret har flere, så åpne samlebilagene hver for seg.",
    "truncated": "Oppgjøret har {total} bilag, men bare de {shown} første vises. Antall, kvittering og listen under er derfor ufullstendige.",
    "signedOff": "Kvittert",
    "signedOffAll": "Ja",
    "signedOffNone": "Nei",
    "signedOffSome": "Delvis",
    "notFound": "Fant ingen avregnede oppgjør for kassapunkt {posRef} med oppgjørsnummer {externalSettlementNo}."
  },
  "settlementDetails": {
    "type": "Oppgjør",
    "incomingType": "Innkommende oppgjør",
    "settlementId": "Oppgjør Id",
    "overviews": "Oversikter",
    "salesOverview": "Salgsoversikt",
    "overviewRpt2": "Betaling pr mapping",
    "overviewRpt3": "Betaling pr ordre",
    "noComments": "Oppgj\u200Børet har ingen komment\u200Barer.",
    "otherInfo": "Annen informasjon",
    "annexes": "Under\u200Bbilag",
    "annexType": "Annex type",
    "annexId": "Annex Id",
    "annexName": "Annex navn",
    "annexRef": "Annex Ref",
    "description": "Beskrivelse",
    "services": "Tjene\u200Bster",
    "bankPos": "Bank\u200Bposer",
    "innbel": "Innbetalt",
    "travels": "Reiser",
    "inventoryChange": "Beholdnings\u200Bendring",
    "article": "Artikkel",
    "refund": "Refusjon",
    "change": "Konduktør\u200Boppgjør",
    "invoice": "Faktura",
    "various": "Diverse",
    "possibleErrors": "Mulige feil",
    "post": "Post",
    "amount": "Beløp",
    "note": "Merknad",
    "paidAmount": "Inn\u200Bbetalt beløp",
    "postnr": "Post\u200Bnr",
    "quantity": "Antall",
    "settlementManager": "Oppgjør\u200Bansvarlig",
    "refnr": "Ref\u200Bnr",
    "nrTicketAttempts": "Ant. billeterings\u200Bforsøk",
    "cred": "Kredit",
    "credit": "Kredit\u200Bering",
    "credits": "Kredit\u200Beringer",
    "debit": "Debet",
    "name": "Navn",
    "errorType": "Feil\u200Btype",
    "salesId": "Selger-\u200BId",
    "cause": "Årsak",
    "nrChange": "Ant. endr\u200Binger",
    "firstSoldOut": "Første ut\u200Bsolgte",
    "quantityRemaining": "Ant. rester\u200Bende",
    "endNr": "Slutt\u200Bnr",
    "startNr": "Start\u200Bnr",
    "articleNr": "Artikkel\u200Bnr",
    "articleInsurance": "Artikkel\u200Bforsikring",
    "rollNo": "Rulle\u200Bnr",
    "regNr": "Artikkel\u200Bnr",
    "nrSold": "Antall solgt",
    "nrErrors": "Antall feil",
    "foreignMva": "F. MVA.",
    "bankNr": "Innkast\u200Bnr",
    "valCode": "Valuta\u200Bkode",
    "reference": "Ref\u200Beranse",
    "amountDiffVal": "Beløp i annen valuta",
    "val": "Val\u200Buta",
    "serialName": "Løpe\u200Bnavn",
    "isInter": "Inter\u200Brail",
    "orderLisa": "Ref\u200Bnr",
    "refundedBy": "Refund\u200Bert av",
    "intercon": "Samtr.",
    "ticketNr": "Billett\u200Bnr",
    "fromStation": "Fra stasjon",
    "toStation": "Til stasjon",
    "fee": "Gebyr",
    "serialNo": "Løpe\u200Bnr",
    "payedAmount": "Betalt beløp",
    "hadError": "Feil\u200Bbill.",
    "travelDate": "Reise\u200Bdato",
    "externalRef": "Ekstern ref.",
    "ticketId": "Billett\u200Bid",
    "interconnection": "Sam\u200Btrafikkode",
    "articlePropertiesName": "Artikkel\u200Bnavn",
    "transactionType": "Transaksjons\u200Btype",
    "hasRequisition": "Rekvi\u200Bsisjon",
    "cashHoldings": "Kontant\u200Bbeholdning",
    "salesPayments": "Betal\u200Binger",
    "salesPayment": "Betaling",
    "salesTransactionSummaries": "Salgs\u200Bpakker",
    "salesTransactionSummary": "Salgs\u200Bpakke",
    "corrections": "Korr\u200Beksjoner",
    "correction": "Korr\u200Beksjon",
    "settlementHasNoX": "Oppgj\u200Børet har ingen {data}.",
    "noCashHoldings": "Oppgjøret har ingen kontant\u200Bbeholdning.",
    "orderVersion": "Ordre:\u200BVersjon",
    "sumTotalAmount": "Totalsum",
    "selectAnnex": "Velg underbilag",
    "showSettledData": "Vis avregnede data",
    "showSettledDataForOrderId": "Vis avregnede data for Ordre Id",
    "replaceWithCorrection": "Erstatt med korreksjon",
    "editCorrection": "Rediger korreksjon",
    "deleteCorrection": "Slett korreksjon",
    "replacedByCorrection": "Erstattet av korreksjon",
    "copyCorrectionOfSettlementConfirmText": "Er du sikker på at du vil kopiere korreksjonsoppgjør #{id}?",
    "copyCorrectionOfSettlementCompleted": "Kopiering fullført",
    "copyCorrectionOfSettlementFailed": "Kopiering feilet",
    "copyCorrectionOfSettlementFailedContent": "Noe gikk galt. Prøv igjen eller kopier manuelt.",
    "copyCorrectionOfSettlementFailedPartial": "Oppgjøret #{id} ble opprettet, men kopiering av linjer feilet. Du navigeres dit nå.",
    "annexTestRun": "Testavregne underbilag",
    "openIncomingCorrectionsTitle": "Opprette korreksjonsoppgjør?",
    "openIncomingCorrectionsText": "Det finnes allerede korreksjonsoppgjør under arbeid. Er du sikker på at du ønsker å opprette et nytt oppgjør?",
    "createCorrection": "Opprett korr.oppgjør",
    "nextSettlement": "Neste i sekvens \u200B ({id})",
    "previousSettlement": "Forrige i sekvens \u200B ({id})",
    "copyCorrectionOfSettlement": "Kopier korr. oppgjør",
    "reverseAll": "Reverser korr. oppgjør"
  },
  "individualAnnexTestRun": {
    "type": "Testavregne underbilag",
    "msgBody": "Message body",
    "testRun": "Testavregne",
    "sales-transaction-summaries": "Salgspakke",
    "sales-payments": "Betaling",
    "sales-credits": "Kreditering",
    "sales-differences": "Differanse",
    "sales-deposits": "Deponering",
    "sales-manual-lines": "Manuell linje",
    "generic-transactions": "Generisk underbilag",
    "annexType": "Underbilagstype"
  },
  "correctionOfSettlement": {
    "type": "Korr\u200Beksjons\u200Boppgjør",
    "incoming_type": "Korreksjonsoppgjør under arbeid",
    "correctedSettlementIdM": "Korr. oppgjør Id",
    "correctedSettlementId": "Korr\u200Bigerer oppgjør Id",
    "correctedBy": "Korr\u200Bigert av",
    "addCorrectionLine": "Legg til linje",
    "correctedSettlementDate": "Korreksjons\u200Boppgjørs\u200Bdato",
    "noAgreementChosen": "Ingen avtale valgt",
    "noChartOfAccountsChosen": "Ingen kontoplan valgt",
    "chooseChartOfAccounts": "Velg kontoplan",
    "goToOrigianSettlement": "Gå til opprin\u200Bnelig oppgjør",
    "noChartsOfAccounts": "Finner ingen kontoplaner",
    "chartOfAccountsNoAgreement": "Valgt kontoplan har ingen avtaler.",
    "chartOfAccountsNoTaxCode": "Valgt kontoplan har ingen MVA koder.",
    "chooseAgreement": "Velg avtale",
    "chooseMapping": "Velg mapping",
    "chooseTaxCode": "Velg MVA kode",
    "noTaxes": "Ingen MVA",
    "withSettlementNo": "Korr\u200Beksjons\u200Boppgjøret fikk oppgjørs\u200Bnummer",
    "description": "Beskrivelse",
    "annexRef": "Annex Ref",
    "transSeq": "Referansenummer",
    "reference": "Referansenummer",
    "userId": "Bruker Id",
    "userIdPosRef": "Bruker Id (POS Ref)",
    "dropMachineId": "IVA POS Ref",
    "roleName": "Rolle",
    "containerType": "Containertype",
    "containerSerialNo": "Container serienummer",
    "orderId": "Ordre Id",
    "orderIdFeedback": "Vennligst fyll ut Ordre Id når Ordre Versjon er fylt ut.",
    "orderVersion": "Ordre versjon",
    "orderVersionFeedback": "Vennligst fyll ut Ordre Versjon når Ordre Id er fylt ut.",
    "standardTab": "Standard",
    "ivaTab": "IVA",
    "mtTab": "MT Deponering (IVA)",
    "tvmTab": "TVM",
    "bccTab": "BCC",
    "cgTab": "Cash Guard",
    "cgReference": "Pose Id",
    "paymentTab": "Betaling",
    "rrnr": "RRNR",
    "terminalId": "Terminal Id",
    "siteId": "BAX nummer",
    "noCorrectionLines": "Ingen korreksjonslinjer er fylt ut",
    "errorRequiredFields": "Obligatoriske felter i følgende faner er ikke fylt ut korrekt:",
    "showDetailsPage": "Vis oppgjørsdetaljer",
    "idReplacedByCorrection": "Korreksjon erstatter id"
  },
  "manualSettlement": {
    "type": "Manuelt oppgjør",
    "mySettlementsInProgress": "Mine oppgjør under arbeid",
    "noSettlementsInProgress": "Ingen oppgjør under arbeid"
  },
  "settlementImport": {
    "type": "Test\u200Bavregning",
    "manualLines": "Manuelle linjer",
    "manualLine": "Manuell linje",
    "differences": "Diff\u200Beranser",
    "difference": "Diff\u200Beranse",
    "deposits": "Depo\u200Bneringer",
    "deposit": "Depo\u200Bnering",
    "credits": "Kredit\u200Beringer",
    "credit": "Kredit\u200Bering",
    "payment": "Betaling",
    "payments": "Betalinger",
    "salespackage": "Salgs\u200Bpakke",
    "salespackages": "Salgs\u200Bpakker",
    "messages": "Meldinger",
    "accountingLines": "Konterings\u200Blinjer",
    "correctSettlement": "Korriger",
    "correctSettlementTrunc": "Korriger...",
    "success": "Status {statusCode}: OK",
    "warning": "Status {statusCode}: Feil under avregning",
    "error": "Status {statusCode}: Alvorlig feil under avregning",
    "showInfoFor": "Viser konterings\u200Blinjer for ",
    "resetSelection": "Nullstill valg",
    "goToCorrectionSettlement": "Gå til korreksjons\u200Boppgjør",
    "noSalesAnnexes": "Ingen under\u200Bbilag av denne typen",
    "noAccountingLines": "Test\u200Bavregningen har ingen konterings\u200Blinjer.",
    "salesAnnexHasNoAccountingLines": "Underbilaget har ingen konterings\u200Blinjer.",
    "selectAnnex": "Vis Konterings\u200Blinjer",
    "pleaseSelectAnnex": "Velg en linje nedenfor",
    "clearingTransactions": "Avregningstransaksjoner",
    "clearingTransactionsShort": "Avr.trans.",
    "salesOrigin": "Salgs\u200Bkanal",
    "referenceId": "Ref\u200Beranse Id",
    "counterpart": "Mot\u200Bpart",
    "method": "Metode",
    "containerSerialNumber": "Container serial number",
    "lookAtMessagesAbove": "Se meldingene over for detaljer",
    "containerType": "Container type",
    "performsTestSettlement": "Utfører test\u200Bavregning",
    "changingIgnoreSequence": "Endrer ute av sekvens verdi",
    "correction": "Korr\u200Beksjon",
    "paymentType": "Betalingstype",
    "isModified": "Endret",
    "oldResult": "Testavregningen er gammel. Trykk oppdater for en ny testavregning",
    "noStatus": "Testavregningen har ukjent status. Kontakt support. ",
    "closeAll": "Lukk alle",
    "openAll": "Åpne alle",
    "bankposer": "Bankposer",
    "bankpose": "Bankpose",
    "bankposenr": "Bankposenr",
    "referanse": "Referanse",
    "oppgjorsansvarlig": "Oppgjørssansvarlig",
    "poster": "Poster",
    "postnr": "Postnr",
    "post": "Post",
    "emptyAnnex": "Ingen underbilag",
    "generic": "Generiske transaksjoner",
    "GenericAnnex": "Generisk underbilag",
    "genericTest": "Generisk test",
    "genericDetails": "Generiske detaljer"
  },
  "settlementBCC": {
    "type": "Opprett BCC oppgjør",
    "foreignAmount": "Beløp annen valuta (EUR)",
    "amount": "Beløp",
    "annexDateTime": "Salgsdato",
    "cancel": "Kansellering",
    "comment": "Kommentar",
    "taxCodes": "MVA Kode",
    "chooseTaxCode": "Velg MVA Kode",
    "annex": "Underbilag",
    "notFound": "Fant ikke det du letet etter",
    "salesDate": "Salgsdato",
    "addAnnex": "Legg til underbilag",
    "manualMapping": "Manuell mapping",
    "bccToastHeader": "Det finnes et uferdig BCC-oppgjør på din maskin.",
    "bccToastDesc": "Ønsker du å bruke dette?"
  },
  "incomingSettlements": {
    "type": "Innkomm\u200Bende oppgj\u200Bør",
    "statusSettlementsPerDate": "Innkomm\u200Bende oppgj\u200Bør per: {date}",
    "statusPerDate": "Status per: {date}",
    "gotoImported": "Gå til importert oppgjør",
    "import": "Importer",
    "importPOS": "Importer alle fra POS",
    "importDist": "Importer alle fra distribusjons\u200Bkanal",
    "importAll": "Importer alle",
    "importSelected": "Importer {value} oppgjør",
    "selectAllFromPOS": "Marker alle fra POS",
    "selectAllFromDist": "Marker alle fra distribusjons\u200Bkanal",
    "importOfSettlementFailed": "Status {statusCode}: Import av oppgjøret feilet",
    "settlementSuccessful": "Status {statusCode}: Oppgjør er vellykket importert",
    "settlementRejectedOnImport": "Status {statusCode}: Oppgjør avvist i import ",
    "settlementMustBeManuallyMoved": "Status {statusCode}: Oppgjøret må flyttes fra *_IMP manuelt",
    "settlementForciblySettled": "Status {statusCode}: Tvangsavregnet oppgjør",
    "settlementWorkInProgress": "Status {statusCode}: Under arbeid",
    "settlementWaitingForImport": "Oppgjøret venter på import",
    "settlementWaitingForImportStatus0": "Status {statusCode}: Oppgjøret venter på import",
    "settlementWaitingForImportCLEOS": "Oppgjøret venter på import direkte i CLEOS",
    "ImportCLEOSNotFound": "Oppgjøret finnes ikke i feillisten",
    "ImportCLEOSTooMany": "Køen for avregning i CLEOS er full, forsøk igjen senere!",
    "allowSettlementOutOfSequence": "Tillat oppgjør ute av sekvens",
    "status0": "Klar til import",
    "status1": "Allerede importert",
    "status2": "Konfigurasjons\u200Bfeil",
    "status3": "Feil i inn\u200Bkommende data",
    "status4": "Integrasjons\u200Bfeil: inkomplett/\u200Binkonsis data",
    "status6": "Tvangs\u200Bavregnet oppgjør",
    "status7": "Under arbeid",
    "unknownStatus": "Ukjent status: {status}"
  },
  "settlementSignOff": {
    "type": "Kvitter for oppgjør",
    "signOff": "Kvitter",
    "signOffScanner": "Kvitter med scanner...",
    "signed": "Kvittert",
    "signedBy": "Kvittert av",
    "includeSigned": "Vis kvitterte",
    "QRCode": "QR kode",
    "QRScan": "Scan QR kode",
    "manualMod": "Manuell modus",
    "helpText": "Pass på at fokuset er i tekstfeltet under før du scanner en QR kode (14 tall). Bytt til manuell modus for å skrive inn POS og oppgjørsnummer manuelt.",
    "manualHelpText": "Tast inn POS (maks 8 tall) og oppgjørsnummer (maks 6 tall) og klikk 'Kvitter' for å kvittere.",
    "signedOffSettlements": "Kvitterte oppgjør",
    "settlementNotFound": "Oppgjør ikke funnet",
    "settlementAlreadySigned": "Oppgjøret er allerede kvittert",
    "signingOff": "Kvitterer oppgjør"
  },
  "incomingSettlement": {
    "type": "Inn\u200Bkommende underbilag",
    "orderVersion": "Ordre\u200Bversjon",
    "externalSettlemenId": "Ekstern ordre Id",
    "timestamp": "Inspeksjons\u200Bdato",
    "orderId": "Ordre Id",
    "settlementId": "Settlement Id"
  },
  "incomingAnnex": {
    "type": "Inn\u200Bkommende underbilag"
  },
  "reportSearch": {
    "type": "Rapport\u200Bsøk",
    "reportName": "Rapport\u200Bnavn",
    "reportNameId": "Rapport\u200Bnavn\u200B/Id",
    "reportMalNameCode": "Rapportmal\u200Bnavn\u200B/Kode",
    "reportId": "Rapport Id",
    "reportParameters": "Rapport\u200Bparametre",
    "orderBy": "Bestilt av",
    "schedule": "Inter\u200Bvall",
    "elapsedTime": "Tids\u200Bbruk",
    "orderDate": "Bestill\u200Bings\u200Bdato",
    "rows": "Rader",
    "active": "Aktiv",
    "paused": "Pauset",
    "discontinued": "Avviklet",
    "status0": "Bestilt",
    "status1": "Utført",
    "status2": "Feilet",
    "status3": "Kansellert",
    "status4": "Ad hoc",
    "status5": "Slettet",
    "status6": "Sletting feilet",
    "status9": "Under arbeid",
    "showAdHoc": "Vis ad hoc rapporter",
    "downloadFile": "Last ned fil",
    "downloadFileAgain": "Last ned fil igjen",
    "mergeSelectedReports": "Slå sammen valgte",
    "downloadSelectedReports": "Last ned valgte ({count})",
    "downloadSelectedReportsLimit": "Maks {max} rapporter kan lastes ned samtidig",
    "rowLimitExceededTooltip": "Rapporten inneholder for mange rader (maks. {maxRows})",
    "downloadEachRowLimitExceeded": "En eller flere valgte rapporter har for mange rader og kan ikke lastes ned",
    "mergeRowLimitExceeded": "De valgte rapportene inneholder for mange rader ({selectedRows} valgt, maks. {maxRows})",
    "showReportParameters": "Vis rapportparametre",
    "mergeReports": "Slå sammen rapporter",
    "numberOfSelectedRowsX": "{rows} rader valgt (maks. {maxRows})",
    "deliverToPartner": "Leveres til partner",
    "deliverToPartnerPlural": "Leveres til partnere",
    "deliverTo": "Leveres til",
    "chartOfAccounts": "Kontoplan",
    "openInBigQuery": "Åpne i BigQuery",
    "openInBigQueryShort": "Åpne i BQ",
    "assignedDaily": "leveres daglig",
    "assignedMonthly": "leveres månedlig",
    "assignedProgrammatic": "bestilles programmatisk",
    "assignedByAgreement": "leveres i henhold til avtale"
  },
  "dataProducts": {
    "type": "Dataprodukt",
    "typeSmall": "dataprodukt",
    "typePlural": "Dataprodukter",
    "id": "Id",
    "code": "Kode",
    "internalDescription": "Intern beskrivelse",
    "externalDescription": "Ekstern beskrivelse",
    "searchLabel": "Kode",
    "activeReportTemplates": "Aktive rapportmaler",
    "noActiveReportTemplates": "Ingen aktive rapportmaler",
    "showNotInUse": "Vis dataprodukter uten aktiv mal",
    "create": "Opprett dataprodukt",
    "fetchError": "Kunne ikke hente dataprodukt"
  },
  "reportTemplates": {
    "type": "Rapport\u200Bmal",
    "typePlural": "Rapport\u200Bmaler",
    "template": "Mal",
    "templateName": "Rapport\u200Bnavn",
    "nameAndId": "Rapport\u200Bmal\u200Bnavn\u200B/\u200BId",
    "frequence": "Frekvens",
    "format": "Format",
    "code": "Kode",
    "codeIdFull": "Malkode (Id)",
    "folder": "Mappe",
    "chooseAccessToReportTemplate": "Velg organis\u200Basjoner som skal bruke rapporten",
    "accessToReportTemplate": "Rapporten brukes av",
    "dynamicReport": "Dynamisk rapport",
    "run": "Kjør",
    "updateTemplate": "Oppdater malen",
    "descriptionUpdate": "For at en rapport\u200Bmal skal kunne bli oppdatert er det viktig at du sender med riktig fil. Det er påkrevd at det du sender med her er en reports.zip fil. Den skal inneholde en fil med endelsen .jrxml og dersom entur logoen skal være med så må denne hete entur.png.",
    "programmatic": "Programmatisk",
    "scheduled": "Skedulert",
    "scheduledAgreement": "Selvbetjent på avtale",
    "scheduledMapping": "Selvbetjent på kont.mapping",
    "scheduledChart": "Selvbetjent på kontoplan",
    "external": "Ekstern opplastning",
    "orderType": "Ordretype",
    "noActiveAgreements": "Rapportmalen har ingen aktive avtaler.",
    "noActiveMappings": "Rapportmalen har ingen aktive mappinger.",
    "noActiveCharts": "Rapportmalen har ingen aktive kontoplaner.",
    "showSql": "Vis SQL",
    "showBigQueryScript": "Vis BigQuery-script",
    "longRetentionPeriod": "Rapportlagring iht. regnskapsloven",
    "templateDropdownError": "Kunne ikke hente rapportmaler",
    "admin": "Maladministrator",
    "activeCharts": "Aktive Kontoplaner",
    "batchType": "Batchtype",
    "fromAccountingMonth": "F.o.m. regnskapsmåned",
    "toAccountingMonth": "T.o.m. regnskapsmåned",
    "ongoing": "Løpende",
    "firstReportDate": "Første rapport",
    "history": "Historikk",
    "toAccountingMonthBeforeFromMonth": "Til og med regnskapsmåned kan ikke være før fra og med regnskapsmåned",
    "noDatasetSubscriptions": "Ingen rapportbestillinger.",
    "versionComment": "Versjonskommentar",
    "exportProductSheet": "Eksporter produktblad",
    "exportProductSheetError": "Kunne ikke eksportere produktblad",
    "productSheetHeading": "Produktblad",
    "productSheetGeneratedAt": "Generert {date}",
    "productSheetColumnsHeading": "Kolonner i rapporten",
    "productSheetColumnName": "Kolonne",
    "productSheetNoColumns": "Ingen kolonner er registrert for denne rapportmalen.",
    "productSheetFooter": "CLEOS · Entur AS"
  },
  "reportProductionPage": {
    "descriptionScheduled": "Manuell bestilling av skedulerte rapporter. Aktiv regnskaps\u200Bmåned og dagens dato brukes som parametre.",
    "description": "Fant du ikke rapporten i rapportsøk? På denne siden kan du kjøre alle skedulerte rapporter, i tillegg til utvalgte programmatiske rapporter.",
    "descriptionBCCFICHE": "Bestiller et konsistent sett med rapporter for testing underveis i måneden. Rapportene produseres automatisk ved månedsslutt.",
    "BCCFICHE": "BCC og FICHE rapporter",
    "scheduledReports": "Skedulerte rapporter",
    "progReports": "Programmatiske rapporter",
    "descriptionProg": "Manuell bestilling av programmatiske rapporter."
  },
  "reportStatistics": {
    "typePlural": "Rapportstatistikk",
    "dateTime": "Nedlastet dato",
    "user": "Bruker",
    "reportId": "Rapport Id",
    "reportName": "Rapport\u200Bnavn",
    "searchReportStatistics": "Søk rapportstatistikk",
    "reportTemplateId": "Rapportmal Id",
    "reportTemplateName": "Rapportmalnavn",
    "generatedDate": "Generert dato",
    "reportFileName": "Filnavn",
    "partnersError": "Klarte ikke hente partnere",
    "retrievedByPartner": "Hentet av partner",
    "retrievedBy": "Hentet av"
  },
  "failedReports": {
    "type": "Feilede rapporter",
    "cancel": "Kanseller",
    "restart": "Omstart",
    "reportName": "Rapport\u200Bnavn",
    "reportTemplateName": "Rapportmal\u200Bnavn",
    "orderDate": "Bestill\u200Bings\u200Bdato",
    "elapsedTime": "Tids\u200Bbruk",
    "schedule": "Inter\u200Bvall",
    "orderBy": "Bestilt av",
    "status2": "Feilet",
    "status3": "Kansellert",
    "status9": "Under arbeid",
    "confirmCancel": "Kansellere rapport?",
    "yesCansel": "Ja, kanseller rapport.",
    "confirmRestart": "Omstart av rapport?",
    "yesRestart": "Ja, omstart av rapport.",
    "confirmCanselText": "Er du sikker på at du vil kansellere rapport {br} {name} ?",
    "confirmRestartText": "Er du sikker på at du vil ta omstart av rapport {br} {name} ?",
    "noContent": "Fant ingen feilede rapporter",
    "showReportParameters": "Vis rapportparametere",
    "showReportErrorMessage": "Vis feilmelding"
  },
  "asyncResult": {
    "ok": "Ok",
    "reportOrdered": "Rapport bestilt.",
    "notFound": "Aktiv måned eller rapport\u200Bmal ikke funnet.",
    "conflict": "Feil. Ikke aktiv rapport\u200Bmal.",
    "reportFinished": "Rapport hentet.",
    "reportNotReady": "Rapporten er ikke klar enda.",
    "reportNoContent": "Rapporten har ingen innhold.",
    "reportNotExist": "Rapporten eksisterer ikke.",
    "reportTemplateNotExist": "Rapportmalen eksisterer ikke.",
    "reportConflict": "Rapport feilet, det har oppstått en konflikt:\n\n{error}",
    "reportFailed": "Rapport feilet.",
    "downloadJobCreated": "Nedlastingsjobb opprettet.",
    "downloadJobNotExist": "Nedlastingsjobben eksisterer ikke.",
    "downloadJobExpired": "Nedlastingsjobben har utløpt.",
    "errorData": "Feil i data",
    "openClearing": "Åpne testavregning",
    "order": "Bestiller",
    "getting": "Henter",
    "rerun": "Kjør på nytt",
    "gettingTestClearing": "Henter testavregnings\u200Bresultat.",
    "thisTakeTime": "Testavregningen ser ut til å ta lang tid. Kom tilbake senere, eller vent på svar.",
    "comeBackLater": "Det kan være noe som henger. Ta kontakt med support.",
    "noTestClearingSaved": "Testavregnings\u200Bresultat finnes ikke. Starter ny test\u200Bavregning.",
    "updatingTestClearing": "Oppdaterer testavregnings\u200Bresultatet",
    "noContact": "Får ikke kontakt med serveren. Kontakt support..",
    "noContent": "Dataene du ønsker å se finnes ikke.",
    "error": "Alvorlig feil. Kontakt support.",
    "clearingResultOK": "Oppgjøret er importert",
    "settlementImport202": "Avregningen er ikke ferdig enda",
    "settlementImportFail": "Avregningen feilet med status: {status}",
    "settlementImportNoContent": "Avregningen har ingen innhold.",
    "settlementImport404": "Feil i data",
    "settlementImport409": "Konflikt i dataene",
    "settlementImport400": "Noe gikk galt",
    "failedTryAgain": "Noe feilet, prøv på nytt.",
    "seeSettlement": "Se testavregning"
  },
  "pointOfSales": {
    "type": "Kassa\u200Bpunkt",
    "typePlural": "Kassa\u200Bpunkter",
    "posRef": "POS Ref",
    "name": "Navn",
    "namePosRef": "Kassapunkt (POS Ref)",
    "location": "Loka\u200Bsjon",
    "locationName": "Salg\u200Bsteds\u200Bnavn",
    "locationId": "Salgs\u200Bsteds\u200Bnummer",
    "locationIdS": "Salgs\u200Bsteds\u200Bnr",
    "createPOS": "Opprett kassa\u200Bpunkt",
    "externalReference": "Ekstern referanse",
    "externalPos": "Eksternt kassa\u200Bpunkt",
    "pos": "POS",
    "posProvider": "Partner provider",
    "posSupplier": "Partner supplier",
    "customerId": "Kunde Id",
    "ansvstnc": "Ansvars\u200Bsted salgs\u200Bsted",
    "ansvstnbEco": "Ansvars\u200Bsted øko\u200Bnomi",
    "projectCode": "Prosjektkode",
    "ansvstnr": "Ansvars\u200Bsted ford\u200Bring",
    "pointOfSaleSearch": "Navn/Id",
    "pointOfSaleExternal": "Hent kassapunkt",
    "tags": "Merkelapper",
    "tag": "Merkelapp",
    "noTags": "Fant ingen merkelapper. Skriv inn manuelt.",
    "tagDropdownError": "Kunne ikke hente merkelapper"
  },
  "point-of-sale": {
    "createNew": "Nytt kassa\u200Bpunkt",
    "posDropdownError": "Kunne ikke hente kassa\u200Bpunkter"
  },
  "distChannel": {
    "type": "Distribusjons\u200Bkanal",
    "typePlural": "Distribusjons\u200Bkanaler",
    "typeShort": "Dist.kanal",
    "ref": "Distribusjons\u200Bkanal Ref",
    "showPOS": "Vis kassa\u200Bpunkter",
    "selfService": "Selv\u200Bbetjent",
    "createDistChannel": "Opp\u200Brett distribusjons\u200Bkanal",
    "externalVersion": "Ekst\u200Bern versjon",
    "externalDistChannel": "Ekst\u200Bern distribusjons\u200Bkanal"
  },
  "dist-channels": {
    "createNew": "Ny distribusjons\u200Bkanal",
    "dropdownError": "Kunne ikke hente distribusjonskanaler"
  },
  "lines": {
    "chooseFromList": "Velg linje ref fra liste",
    "createLine": "Opprett linje",
    "createNew": "Ny linje",
    "fetchExternal": "Hent ekst\u200Bernt",
    "fillInIdBeforeFetching": "Fyll inn en id før du prøver å hente fra eksternt register",
    "getExternalSuccess": "Linje Id ble funnet i eksternt register",
    "id": "Linje Id",
    "longDistanceTrain": "Fjerntog",
    "interoperableTrain": "Interoperabelt tog",
    "manuelRef": "Skriv inn linje ref manuelt",
    "noExternalRefs": "Fant ingen eksterne linje refs til selskapet. Skriv inn manuelt.",
    "ref": "Linje ref",
    "type": "Linje",
    "typeSmall": "linje",
    "typePlural": "Linjer",
    "fareProductAuthorities": "Interoperable takstmyndigheter",
    "fareProductAuthoritiesTooltip": "Det skilles på forskjellige takstmyndigheter med komma"
  },
  "segment1": {
    "id": "Organis\u200Basjon Id",
    "type": "Organis\u200Basjon",
    "typePlural": "Organis\u200Basjoner",
    "code": "Selskaps\u200Bkode",
    "codePlural": "Selskaps\u200Bkoder",
    "nameAndCode": "Organis\u200Basjon (kode)",
    "ref": "Organis\u200Basjons Ref",
    "refS": "Org\u200B Ref",
    "organisationNr": "Organis\u200Basjons\u200Bnr",
    "customerNumber": "Kunde\u200Bnr",
    "create": "Opprett organis\u200Basjon",
    "createNew": "Ny organis\u200Basjon",
    "externalOrganisation": "Ekstern organis\u200Basjon",
    "supplierRef": "POS supplier Ref",
    "providerRef": "POS provider Ref",
    "codeSpace": "CodeSpace",
    "bqProject": "BigQuery prosjekt",
    "noActiveAgreements": "Organisasjonen har ingen aktive avtaler.",
    "noActiveMappings": "Organisasjonen har ingen aktive mappinger.",
    "noActiveAccountingRules": "Organisasjonen har ingen aktive Konteringsregler.",
    "externalOrganisationDropdownError": "Kunne ikke hente organisasjoner"
  },
  "segment2": {
    "id": "Ansvars\u200Bsted Id",
    "type": "Ansvars\u200Bsted",
    "name": "Ansvarsstedsnavn",
    "typeSmall": "ansvars\u200Bsted",
    "typePlural": "Ansvars\u200Bsteder",
    "code": "Ansvars\u200Bsteds\u200Bkode",
    "create": "Opp\u200Brett ansvars\u200Bsted",
    "createNew": "Nytt ansvars\u200Bsted",
    "createAnother": "Nytt ansvars\u200Bsted",
    "noActiveAgreements": "Ansvarsstedet har ingen aktive avtaler.",
    "noLines": "Ansvarsstedet har ingen linjer.",
    "noActiveMappings": "Ansvarsstedet har ingen aktive mappinger.",
    "noActiveAccountingRules": "Ansvarsstedet har ingen aktive Konteringsregler.",
    "dropdownError": "Kunne ikke hente ansvarssteder"
  },
  "segment3": {
    "id": "Konto Id",
    "type": "Konto",
    "typePlural": "Kontoer",
    "name": "Konto\u200Bnavn",
    "create": "Opprett konto",
    "createNew": "Ny konto",
    "createAnother": "Ny konto",
    "noActiveAccountingRules": "Konto har ingen aktive Konteringsregler.",
    "noActiveMappings": "Konto har ingen aktive mappinger.",
    "dropdownError": "Kunne ikke hente kontoer"
  },
  "segment4": {
    "id": "Aktivitet Id",
    "type": "Aktivitet",
    "typePlural": "Aktiviteter",
    "name": "Aktivitets\u200Bnavn",
    "code": "Aktivitets\u200Bkode",
    "create": "Opprett aktivitet",
    "createNew": "Ny aktivitet",
    "createAnother": "Ny aktivitet",
    "noActiveMappings": "Aktiviteten har ingen aktive mappinger.",
    "noLines": "Aktiviteten har ingen linjer.",
    "noActiveAccountingRules": "Aktiviteten har ingen aktive Konteringsregler.",
    "dropdownError": "Kunne ikke hente aktiviteter"
  },
  "segment5": {
    "id": "Prosjekt Id",
    "type": "Prosjekt",
    "typePlural": "Prosjekter",
    "object": "Objekt",
    "code": "Prosjekt\u200Bkode",
    "name": "Prosjekt\u200Bnavn",
    "create": "Opprett prosjekt",
    "createNew": "Nytt prosjekt",
    "createAnother": "Nytt prosjekt",
    "noActiveAgreements": "Prosjektet har ingen aktive avtaler.",
    "noLines": "Prosjektet har ingen linjer.",
    "noActiveAccountingRules": "Prosjektet har ingen aktive Konteringsregler.",
    "noActiveMappings": "Prosjektet har ingen aktive mappinger.",
    "dropdownError": "Kunne ikke hente prosjekter"
  },
  "segment6": {
    "id": "Spes\u200Bkode Id",
    "type": "Spes\u200Bkode",
    "typePlural": "Spes\u200Bkoder",
    "code": "Spes\u200Bkode",
    "name": "Spes\u200Bkodenavn",
    "create": "Opprett spes\u200Bkode",
    "createNew": "Ny spes\u200Bkode",
    "createAnother": "Ny spes\u200Bkode",
    "noLines": "Speskode har ingen linjer.",
    "noActiveMappings": "Speskode har ingen aktive mappinger.",
    "dropdownError": "Kunne ikke hente speskoder"
  },
  "segment7": {
    "id": "MVA Id",
    "type": "MVA kode",
    "typePlural": "MVA koder",
    "name": "MVA Navn",
    "code": "Lokal MVA kode",
    "codeShort": "Lok. MVA",
    "standardCode": "Standard MVA kode",
    "standardCodeShort": "Std. MVA",
    "create": "Opprett MVA kode",
    "createNew": "Ny MVA kode",
    "createAnother": "Ny MVA kode",
    "taxRate": "Prosent\u200Bsats",
    "taxRateShort": "%",
    "mvaRate": "MVA%",
    "mvaAmount": "MVA beløp",
    "noActiveMappings": "MVA koden har ingen aktive mappinger.",
    "noActiveAgreements": "MVA koden har ingen aktive avtaler.",
    "dropdownError": "Kunne ikke hente MVA koder"
  },
  "transactionTypes": {
    "name": "Transaksjonstype",
    "namePlural": "Transaksjonstyper",
    "create": "Opprett transaksjonstype",
    "showDiscontinued": "Vis avviklede transaksjonstyper",
    "typeValidation": "Typen kan kun inneholde bokstaver og understreker",
    "dropdownError": "Kunne ikke hente transaksjonstyper"
  },
  "chartsOfAccounts": {
    "adminId": "Kontoplan administrator",
    "id": "Kontoplan Id",
    "name": "Kontoplan",
    "namePlural": "Kontoplaner",
    "code": "Kode",
    "create": "Opprett kontoplan",
    "showDiscontinued": "Vis avviklede kontoplaner",
    "agreement": "Avtale for øreavrunding",
    "accountingRule": "Konteringsregel for øreavrunding",
    "isAccountingMappingEnabled": "Kontoplanen benytter kun avregningsmappinger som støtter konteringsmapping"
  },
  "accountingMonth": {
    "type": "Regnskaps\u200Bmåned",
    "typePlural": "Regnskaps\u200Bmåneder",
    "createNew": "Opprett Regnskaps\u200Bmåned",
    "closeable": "Kan avsluttes",
    "notStarted": "Ikke påbegynt",
    "exchangeRateEUR": "Valutakurs Euro",
    "accountingPeriod": "Regnskapsperiode",
    "mustBeNextMonth": "Regnskaps\u200Bmånedens fra dato må være i {month}",
    "accountingMonthDropdownError": "Kunne ikke hente regnskapsmåneder",
    "fetchExchangeRate": "Hent valutakurs",
    "exchangeRateFetched": "Valutakurs hentet fra Norges Bank. Kontroller og lagre.",
    "exchangeRateUnavailable": "Valutakurs ikke tilgjengelig",
    "exchangeRateFetchFailed": "Kunne ikke hente valutakurs fra Norges Bank",
    "exchangeRateNotPublished": "Valutakurs for {period} er ikke publisert av Norges Bank ennå"
  },
  "operatingMessages": {
    "type": "Drifts\u200Bmelding",
    "typeSmall": "drifts\u200Bmelding",
    "typePlural": "Drifts\u200Bmeldinger",
    "createNew": "Opprett drifts\u200Bmelding",
    "createdBy": "Opprettet av",
    "deleteOperatingMessage": "Slett drifts\u200Bmelding",
    "message": "Melding",
    "noActiveMessages": "Ingen aktive driftsmeldinger."
  },
  "partners": {
    "refS": "Org\u200B Ref",
    "typePlural": "Partnere",
    "type": "Partner",
    "create": "Opprett partner",
    "ref": "Organis\u200Basjons Ref",
    "bqProject": "BigQuery prosjekt",
    "codeSpace": "CodeSpace",
    "partnerDropdownError": "Kunne ikke hente partnere"
  },
  "users": {
    "userId": "Bruker\u200Bnavn",
    "type": "Bruker",
    "typePlural": "Brukere",
    "userSmall": "bruker",
    "create": "Opprett Bruker",
    "createNew": "Ny Bruker",
    "createAnother": "Ny bruker",
    "dateCreated": "Dato opprettet",
    "deleteUser": "Slett bruker...",
    "userSearch": "Brukernavn/Id",
    "activeDate": "Sist pålogget dato",
    "activeUser": "Aktiv"
  },
  "groups": {
    "type": "Gruppe",
    "typePlural": "Grupper",
    "groupSmall": "gruppe",
    "create": "Opprett Gruppe",
    "createNew": "Ny Gruppe",
    "createAnother": "Ny gruppe",
    "dateCreated": "Dato opprettet",
    "selectRights": "Tildel rettigheter",
    "selectedRights": "Tildelte rettigheter",
    "selectGroups": "Tildel grupper",
    "selectedGroups": "Tildelte grupper",
    "deleteGroup": "Slett gruppe...",
    "groupSearch": "Gruppe/Id"
  },
  "refer": {
    "type": "Ref",
    "typePlural": "Ref",
    "nameRefPlural": "Navn på ref",
    "nameRef": "Navn på ref",
    "nameRefNew": "Navngi ref",
    "createRef": "Navngi ref",
    "name": "Navn",
    "timestamp": "Dato endret",
    "getRefs": "Hent ref",
    "refsDesc": "Egendefinerte navn på ekstern ref (id)",
    "notFound": "Ref ikke funnet i eksternt register, kan opprettes",
    "foundRef": "Ref funnet, kan navngis"
  },
  "manual-refs": {
    "createNew": "Navngi ref"
  },
  "xledger": {
    "type": "XLedger overføring",
    "typePlural": "Xledger overføringer",
    "xledger": "XLedger",
    "templateId": "Mal Id",
    "templateAndId": "Mal (Id)",
    "reportId": "Rapport Id",
    "batchId": "Batch Id",
    "removed": "Fjernet",
    "transferred": "Overførte",
    "dummy": "Midlertidige verdier",
    "started": "Påbegynt",
    "transferCompleted": "Fullført",
    "comment": "Kommentar",
    "signOff": "Kvitter...",
    "signOffTitleOne": "Du er i ferd med å kvittere {value} overføring",
    "signOffTitle": "Du er i ferd med å kvittere {value} overføringer",
    "signOffDescription": "Under kan du legge til en kommentar om ønskelig.",
    "status0": "Påbegynt",
    "status1": "Overført",
    "status2": "Prøv igjen",
    "status3": "Feilet",
    "status4": "Kansellert",
    "status5": "Ingen aksjon",
    "status6": "Pauset",
    "statusText": "Status beskrivelse",
    "showDummy": "Vis midlertidige verdier...",
    "showComment": "Vis kommentar...",
    "updateHeading": "Oppdatere til status Pauset?",
    "updateText": "Overføring av hele rapportmal {value} stoppes!",
    "update": "Ja, oppdater."
  },
  "keyboardNavigation": {
    "type": "Tastatur\u200Bnavigering",
    "keyboardDescription": "På denne siden finner du hvilke taster og taste\u200Bkombinasjoner som er tilgjengelig dersom du ønsker å navigere CLEOS med tastaturet.",
    "keyboardCombos": "Tastatur\u200Bkombinasjoner",
    "effects": "Effekt",
    "tab": "Flytt fokuset til neste element.",
    "shiftTab": "Flytt fokuset til forrige element.",
    "shiftClick": "Marker alle avmerkingsbokser mellom forrige klikk og denne.",
    "space1": "Veksle sjekk\u200Bbokser.",
    "space2": "Åpne/\u200BLukke elementer med flere valg.",
    "or": "eller",
    "upDown1": "Bla opp og ned på siden.",
    "upDown2": "Bla opp og ned inne i et element.",
    "enter1": "Aktivere linker eller knapper.",
    "enter2": "Gjøre et søk når man befinner seg i et søkefelt.",
    "esc1": "Lukke elementet som har fokus.",
    "esc2": "Tømme nedtrekks\u200Blister.",
    "leftRight": "For\u200Bflytte seg gjennom faner (Oppgjørssøk).",
    "ctrlUpDown": "Bevege seg mellom grupper av tekstinputfelter (Korreksjonslinjer, BCC oppgjør, Konteringsregler)",
    "ctrlAltT": "Skru av/på norske navn på kolonner i tabeller.",
    "modE": "Bytt til redigering.",
    "modS": "Lagre skjemaet.",
    "modO": "Opprett ny.",
    "modI": "Importer oppgjør.",
    "groupGlobal": "Global",
    "groupEditForms": "Redigering og lagring",
    "altUpDown": "Navigere mellom resultater på detaljsiden.",
    "altLeftRight": "Navigere mellom oppgjør i sekvens (Oppgjørsdetaljer)."
  },
  "statusPage": {
    "heading": "Status",
    "statusPerDate": "Status per: {date}",
    "accountingMonth": "Regnskapsmåned {date}",
    "futureAccountingMonth": "Fremtidige regnskapsmåneder",
    "settlementsImportAccountingMonth": "Oppgjør avregnet i regnskapsmåneden",
    "settlements24": "Oppgjør avregnet siste 24 timer",
    "incomingSettlements": "Feilede oppgjør",
    "settlementsQueue": "Oppgjør i kø",
    "settlementStatus3": "Oppgjør med status 3",
    "failedReports": "Feilede rapporter",
    "reportsQueue": "Rapporter i kø",
    "grafana": "Grafana"
  },
  "landingPages": {
    "oopsHeader": "Din på\u200Blogging har utgått",
    "oopsDescription": "Det er for lenge siden sist du logget deg på - vennligst",
    "login": "logg inn på nytt.",
    "notFoundHeader": "Bomtur",
    "notFoundDescription": "Adressen du forsøkte å gå til ({code}) finnes ikke eller har blitt flyttet til et annet sted.",
    "reachOut": "Ta kontakt dersom dette ikke stemmer overens med forventningene dine.",
    "goBack": "Gå tilbake",
    "unauthorizedTitle": "Ingen tilgang",
    "unauthorizedMessage": "Du har ikke tillatelse til å se innholdet på denne siden.",
    "unauthorizedMessage2": "Ta kontakt med administrator i din organisasjon hvis du trenger tilgang. ",
    "unauthorizedMessage3": "NB: Du må logge ut og inn i CLEOS for å oppdatere tilganger",
    "missingPrivilege": "Mangler rettighet: {privilege}"
  },
  "warnings": {
    "invalidType": "Verdi må være av type {type}",
    "invalidValueX": "Ugyldig {value}",
    "invalidValue": "Ugyldig verdi",
    "upperCaseUnderscore": "Kun store bokstaver og understreker er tillatt",
    "noChosenWontBeUsed": "Ingen segment valgt. Verdien blir ikke tatt med.",
    "atleastOne": "Velg minst èn av disse",
    "noContent": "Fant ingen data",
    "noData": "Ingen data",
    "exactLength": "Feltet må være nøyaktig {number} tegn",
    "maxLength": "Feltet kan ikke være lengre enn {number} tegn",
    "maxValue": "Tallet kan ikke være større enn {number}",
    "minValue": "Tallet kan ikke være mindre enn {number}",
    "noValueInRegister": "Fant ikke {value} i vårt register",
    "noResultX": "Fant ingen {data}",
    "invalidDate": "Ugyldig dato (dd.mm.åååå)",
    "dateCannotBeBefore": "Dato kan ikke være før {date}",
    "invalidFactor": "Ugyldig faktor",
    "invalidExchangeRateEUR": "Ugyldig valuta",
    "invalidEmail": "E-post\u200Badresse er ugyldig",
    "inputCannotBeEmpty": "Feltet må fylles ut",
    "inputCannotBeEmptyX": "{value} må fylles inn",
    "inputCannotBeEmptySelectValue": "Feltet må fylles ut, velg en verdi i listen",
    "inputTwoOrMoreChars": "Skriv to eller flere tegn",
    "inputNeedValidValue": "Feltet må fylles ut med en gyldig verdi",
    "toDateStatus": "Feltet må fylles ut med en gyldig verdi dersom status settes til avviklet",
    "agreementMustBeSelected": "Avtale må velges",
    "organisationMustBeSelected": "Organisasjon må velges",
    "correctionmappingMustBeSelected": "Korreksjonsmapping må velges",
    "manualmappingMustBeSelected": "Korreksjonsmapping må velges",
    "amountMustBeFilledIn": "Beløp må fylles inn",
    "amountCannotBeNegative": "Beløp kan ikke være negativt",
    "descriptionMustBeFilledIn": "Beskrivelse må fylles inn",
    "vatCodeMustBeSelected": "MVA kode må velges",
    "agreementHasNoMappings": "Avtalen har ingen korreksjons\u200Bmappinger.",
    "agreementHasNoTaxCodes": "Avtalen har ikke moms\u200Bkoder",
    "invalidValueSelectFromListOrCreateNew": "Ugyldig verdi. Velg fra listen eller opprett ny med opprett-knappen i listen",
    "noExternalContent": "Fant ikke i eksternt register",
    "cannotContactExternalRegister": "Eksternt register ikke tilgjengelig. Informasjonen kan være noe ufullstendig.",
    "registerOutdated": "Fant en nyere version i eksternt register, vennligst oppdater",
    "typeToSearch": "Skriv for å søke",
    "noDistributionChannel": "Distribusjons\u200Bkanal må velges",
    "noSettlementDate": "Oppgjørsdato må velges",
    "noPosRef": "POS Ref må velges",
    "warning400": "Feil i innsendte data",
    "warningMessage400": "Verdiene du har sendt inneholder data som serveren ikke kunne forstå, vennligst endre dem og prøv igjen. Ta kontakt med utviklings\u200Bteamet dersom dette går mot dine forventninger.",
    "warningMessage403": "Du har ikke tilgang til å gjøre denne handlingen.",
    "warning404": "Ikke funnet",
    "warningMessage404": "Informasjonen du leter etter, eksisterer ikke.",
    "warning409": "Det har oppstått en konflikt",
    "warningMessage409": "Verdiene du har sendt inn bryter med forretnings\u200Blogikken. Vennligst endre dem og prøv igjen. Ta kontakt med utviklings\u200Bteamet dersom dette går mot dine forventninger og legg ved følgende kode: ",
    "warning400Default": "Dataen stemmer ikke",
    "warning403": "Ingen tilgang",
    "warningMessage400Default": "Informasjonen du prøvde å søke opp eller lagre er ikke på et format som serveren forstår. Endre verdiene og prøv igjen. Ta kontakt dersom dette ikke stemmer overens med dine forventninger.",
    "inValidURL": "Ugyldig URL. Eksempel: https://example.com",
    "tooFewChar6": "Trenger 6 eller flere tegn",
    "corruptJson": "Feil i JSON struktur",
    "corruptJsonLong": "Dataene er ikke en gyldig JSON struktur. Klikk oppdater for å oppdatere testavregningsresultatet. Om problemet ikke løses, kontakt support med oppgjørsnummer.",
    "noValueChosen": "Ingen verdi er valgt. Viser navn fra kopiert mapping",
    "wrongType": "Ikke en {data}",
    "noIdFound": "Ingen id funnet. Kan ikke hente data.",
    "noNameFound": "Fant inget navn tilknyttet id'en",
    "nameFound": "Navn funnet",
    "invalidRef": "Ugyldig REF",
    "invalidFactorRange": "Faktor må være mellom 0 og 100",
    "maxDecimals": "Maksimalt {number} desimaler tillatt"
  },
  "error": {
    "error504": "Tiden gikk ut.",
    "errorMessage504": "Handlingen du prøver å gjennomføre tok for lang tid. Prøv på nytt og ta kontakt med utviklings\u200Bteamet dersom feilen vedvarer.",
    "error500Default": "Feil oppstått hos server.",
    "errorMessage504Default": "Det har oppstått en feil på server\u200Bsiden, ta kontakt med utviklings\u200Bteamet og gi dem denne koden:",
    "defaultError": "Det har skjedd en uventet feil!"
  },
  "columns": {
    "accountingDate": "Bokførings|dato",
    "accountingMappingEnabled": "Kan brukes til|konteringsmapping",
    "accountingMappingId": "Mapping |Id",
    "accountingMonthId": "Regnskapsmnd",
    "accountingRuleId": "Kont.|regel Id",
    "accountingPartnerId": "Partner Id",
    "acctAmount": "Bokføringsbeløp",
    "acctCredit": "Bokføring Kredit",
    "acctCreditPeriod": "Bokført Kredit Periode",
    "acctCtx": "Bokføring",
    "acctCtx_name": "Bokføringsnavn",
    "acctCtx_s1": "Segment 1",
    "acctCtx_s2": "Segment 2",
    "acctCtx_s3": "Segment 3",
    "acctCtx_s4": "Segment 4",
    "acctCtx_s5": "Segment 5",
    "acctCtx_s6": "Segment 6",
    "acctCtx_s7": "Segment 7",
    "acctCtx_test": "Bokføring Test",
    "acctCtx_testAcct": "Bokføring Test 2",
    "acctDate": "Bokføringsdato",
    "acctDateOrigPeriod": "Original Periodisert Bokføringsdato",
    "acctDatePeriod": "Effektiv Periodisert Bokføringsdato",
    "acctDebit": "Bokføring Debit",
    "acctDebitPeriod": "Bokført Debit Periode",
    "acctLineId": "Kont.linje Id",
    "acctLocalTaxcode": "Bokføring Lok. MVA",
    "acctLocalTaxrate": "Bokføring MVA Sats",
    "acctRuleId": "Bokføringsregel Id",
    "acctRulelineId": "Bokføringsregellinje Id",
    "acctStdTaxcode": "Bokføring Std. MVA",
    "agmtCtx": "Avtale",
    "agmtCtx_acct": "Avtale Kontonr.",
    "agmtCtx_ap": "Avtale AP",
    "agmtCtx_ar": "Avtale AR",
    "agmtCtx_gl": "Avtale GL",
    "agmtCtx_name": "Avtalenavn",
    "agmtCtx_org": "Avtale Org.nr.",
    "agmtCtx_test": "Avtale Test",
    "agmtCtx_text": "Avtale Kommentar",
    "agmtId": "Avtale Id",
    "agmtOrgCtx": "Avtale Organisasjon",
    "agmtOrgCtx_code": "Avtale Selskapskode",
    "agmtOrgId": "Avtale Org. Id",
    "agmtOrgRef": "Avtale Org. Ref",
    "agmtRef": "Avtale Ref",
    "agmtStdTaxcode": "Avtale Std. MVA",
    "agreementId": "Avtale |Id",
    "agreementName": "Avtale|navn",
    "agreementRef": "Avtale |ref",
    "agreementType": "Avtale|type",
    "alternativeOwnerFilterString": "Andelseier​filter",
    "annexAmount": "Annex Beløp",
    "annexCancelled": "Annex Kansellering",
    "annexCtx": "Annex",
    "annexCtx_authority": "Annex Takstmyndighet",
    "annexCtx_cSet": "Annex Kandidatsett",
    "annexCtx_desc": "Annex Beskrivelse",
    "annexCtx_dRightRef": "Annex Rabatt Rettighet",
    "annexCtx_entGivenRef": "Annex Reiserettighet Ref",
    "annexCtx_extRef": "Annex Ekstern Ref",
    "annexCtx_fareClasses": "Annex Reiseklasse",
    "annexCtx_fpId": "Annex Reiseprodukt Id",
    "annexCtx_fpRef": "Annex Reiseprodukt Ref",
    "annexCtx_fseRef": "Annex Reisestrekning Ref",
    "annexCtx_from": "Annex Fra Stoppested",
    "annexCtx_legs": "Annex Til/Fra Stasjon",
    "annexCtx_oLineId": "Annex Ordrelinje Id",
    "annexCtx_oLineVersion": "Annex Ordrelinje Versjon",
    "annexCtx_operator": "Annex Operatør",
    "annexCtx_paymentBrand": "Annex Betalingsmerke",
    "annexCtx_paymentTypeGroup": "Annex Betalingsgruppe",
    "annexCtx_paymentType": "Annex Betalingstype",
    "annexCtx_reservingRef": "Annex Reservasjon Ref",
    "annexCtx_rrnr": "Annex RRNR",
    "annexCtx_sjLineCode": "Annex Linjekode",
    "annexCtx_sjLineName": "Annex Linjenavn",
    "annexCtx_sjLineRef": "Annex Linje Ref",
    "annexCtx_sjPcode": "Annex Service Journey Privatkode",
    "annexCtx_sjRef": "Annex Service Journey Ref",
    "annexCtx_spRef": "Annex Salgspakke Ref",
    "annexCtx_to": "Annex Til Stoppested",
    "annexCtx_upRef": "Annex Brukerprofil Ref",
    "annexCtx_usageValidityRef": "Annex Gyldighet Ref",
    "annexCtx_veRef": "Annex Validerbart Produkt Ref",
    "annexCtx_zCount": "Annex Antall Soner",
    "annexCtx_zDist": "Annex Soner Distanse",
    "annexCtx_zones": "Annex Soner Ref",
    "annexForeignAmount": "Annex Utl. Beløp",
    "annexForeignCurrency": "Annex Utl. Valuta",
    "annexGuid": "Annex GUID",
    "annexLocalTaxcode": "Annex Lok. MVA",
    "annexMsgSubjectRef": "Annex Message Subject Ref",
    "annexRef": "Annex Ref",
    "annexStdTaxcode": "Annex Std. MVA",
    "annexTaxrate": "Annex MVA Sats",
    "annexTravelTimestamp": "Annex Reisetidspunkt",
    "ansvstnb": "Ansvars​sted øko​nomi",
    "ansvstnc": "Ansvars​sted salgs​sted",
    "ansvstnr": "Ansvars​sted ford​ring",
    "apBatchId": "AP Batch Id",
    "arBatchId": "AR Batch Id",
    "baseAmount": "Base |amount",
    "baseAmount.amount": "Base |amount",
    "batchId": "Batch Id",
    "bqProject": "BigQuery prosjekt",
    "candidateFilterString": "Kandidat|filter",
    "changes": "Midlertidige verdier",
    "chartOfAccountsRef": "Kontoplan",
    "chosenColumns": "Valgte kolonner:",
    "clearingMonthId": "Avregn. Mnd.",
    "clearingType": "Variant",
    "cleosFilename": "Rapportnavn",
    "cleosStatus": "Status",
    "codeSpace": "CodeSpace",
    "comission": "Provi​sjon",
    "companyCode": "Selskaps|kode",
    "companyName": "Navn",
    "companycode": "Selskaps|kode",
    "copyOrgRefs": "Leveres til",
    "createPosMode": "Automatisk POS",
    "credit.amount": "Kredit",
    "dchannelCtx": "Distribusjonskanal",
    "dchannelCtx_name": "Salgskanal Navn",
    "dchannelId": "Salgskanal Id",
    "dchannelRef": "Salgskanal Ref",
    "debit.amount": "Debet",
    "deliverSalesdescription": "Salgs|beskrivelse",
    "deliverTo": "Avtale​|type",
    "description": "Beskrivelse",
    "distributionChannelRef": "Distribusjons​kanal",
    "download": "Last ned/Åpne i BigQuery",
    "dummy": "Midlertidige verdier",
    "elapsedTime": "Tids\u200Bbruk",
    "foreignAmount.amount": "F.beløp",
    "foreignAmount.currency": "F.valuta",
    "fromDate": "F.o.m",
    "glBatchId": "GL Batch Id",
    "id": "Id",
    "inBatchId": "IN Batch Id",
    "isAccountingMappingEnabled": "Benytter|konteringsmapping",
    "kvitter": "Kvitter",
    "legAuthority": "Authority Leg",
    "legLineRef": "Line Ref Leg",
    "legOperator": "Operator Leg",
    "legServiceJourneyPrivateCode": "Service Journey Private Code",
    "legServiceJourneyRef": "Service Journey Ref Leg",
    "localName": "Navn",
    "localTaxCode": "Lokal |MVA kode",
    "localTaxRate": "Prosentsats",
    "mappingAmount": "Avregn.mapping Beløp",
    "mappingClearingType": "Avregn.mapping Avregn.type",
    "mappingCtx": "Avregningsmapping",
    "mappingCtx_name": "Avregn.mappingnavn",
    "mappingCtx_period": "Avregn.mapping Periode",
    "mappingId": "Avregn.mapping Id",
    "mappingName": "Mapping|navn",
    "mappingSignoff": "Mapping Må Kvitteres",
    "name": "Navn",
    "code": "Kode",
    "numOfRowsRemoved": "Fjernet",
    "numOfRowsTransferred": "Overførte",
    "objkode": "Objekt kode",
    "occurs": "Occurs",
    "orderDateTime": "Bestill\u200Bings\u200Bdato",
    "orderBy": "Bestilt av",
    "orgNumber": "Organisasjons-|/​kundenr",
    "organisation": "Selskap",
    "organisationId": "Organisasjons |id",
    "organisationRef": "Organis​asjons Ref",
    "posCreationMode": "Automatisk POS",
    "posCtx": "Kassapunkt",
    "posCtx_locName": "Kassapunkt Lokasjonsnavn",
    "posCtx_locRef": "Kassapunkt Lokasjon Ref",
    "posCtx_name": "Kassapunkt Navn",
    "posCtx_pCode": "Kassapunkt Privatkode",
    "posId": "Kassapunkt Id",
    "posProviderOrgRef": "Selger Org. Ref",
    "posProviderRef": "Selger Ref",
    "posRef": "Kassapunkt Ref",
    "posSalesLocationRef": "POS Sales Location Ref",
    "posSupplierOrgRef": "Leverandør Org. Ref",
    "posSupplierRef": "Leverandør Ref",
    "providerRef": "Selger Ref",
    "reportId": "Rapport Id",
    "reportTemplateName": "Rapportmal\u200Bnavn",
    "rows": "Rader",
    "ruleName": "Konterings|regelnavn",
    "salesAgreementRef": "Sales Agreement Ref",
    "salesDate": "Salgs|dato",
    "salesDiscountRightRef": "Sales Discount Right Ref",
    "salesFareProductRef": "Sales Fare Product Ref",
    "salesFareStructureElementRef": "Sales Fare Structure Element Ref",
    "salesFromStopPlace": "Sales from Stop Place",
    "salesIntervalDistance": "Sales Interval Distance",
    "salesOrderId": "Ordre Id : |Versjon",
    "salesPaymentRrnr": "RRNR",
    "salesSalePackageRef": "Sales Sale Package Ref",
    "salesStandardTaxCode": "Salg Standard MVA kode",
    "salesStartTime": "Sales Start Time",
    "salesTaxRate": "Salg MVA rate",
    "salesToStopPlace": "Sales to Stop Place",
    "salesUsageParameterRef": "Sales Usage Parameter Ref",
    "salesUserProfileRef": "Sales User Profile Ref",
    "salesValidableElementRef": "Sales Validable Element Ref",
    "salesZonesRef": "Sales Zones Ref",
    "salgnavn": "Salg​steds​navn",
    "scheduled": "Inter\u200Bvall",
    "segment1": "Selskaps|kode",
    "segment2": "Ansvars|sted",
    "segment3": "Konto|nr",
    "segment4": "Aktivitet",
    "segment5": "Prosjekt",
    "segment6": "Spes|kode",
    "segment7": "Standard |MVA kode",
    "signOff": "Kvittering",
    "signedOffBy": "Kvittert av",
    "signoff": "Må kvitteres",
    "smntCtx": "Oppgjør",
    "smntCtx_externalNo": "Eksternt Oppgjørsnr.",
    "smntCtx_externalDate": "Ekstern Oppgjørsdato",
    "smntDate": "Oppgjørsdato",
    "smntId": "Oppgjør Id",
    "smntNumber": "Oppgjørsnr.",
    "specialOrderCause": "Special Order Cause",
    "specialOrderOrgRef": "Special Order Org Ref",
    "specialOrderRelated": "Special Order Related",
    "standardCode": "Standard MVA kode",
    "started": "Påbegynt",
    "status": "Status",
    "status.text": "Status",
    "supplierRef": "POS supplier Ref",
    "TAccountView": "T-konto visning",
    "tag": "Merkelapp",
    "taxRate": "Prosent|sats",
    "templateId": "Mal Id",
    "timestamp": "Tidspunkt",
    "toDate": "T.o.m",
    "transCorrectionId": "Trans. Korreksjon Id",
    "transCreditId": "Trans. Kredit Id",
    "transCtx": "Transaksjon",
    "transCtx_sumTotalAmount": "Trans. Bruttosum",
    "transDepositId": "Trans. Deponering Id",
    "transDiffId": "Trans. Differanse Id",
    "transGenericId": "Trans. Generisk Id",
    "transManualId": "Trans. Manuell Id",
    "transOrderId": "Trans. Ordre Id",
    "transOrderVersion": "Trans. Ordre Versjon",
    "transPaymentId": "Trans. Betaling Id",
    "transStsId": "Trans. Salg Id",
    "transTimestamp": "Trans. Tidspunkt",
    "transType": "Trans. Type",
    "transactionType": "Transaksjons|type",
    "transferCompleted": "Fullført",
    "type": "Transaksjonstype",
    "version": "Versjon",
    "clearingTransType": "Avregningstype",
    "chartOfAccountsCode": "Kontoplan kode"
  },
  "auditlog": {
    "userId": "Brukernavn",
    "typePlural": "Auditlogger",
    "type": "Auditlog",
    "dateTime": "Utført dato",
    "privilege": "Rettighet",
    "uri": "Url",
    "method": "Metode",
    "status": "Status",
    "params": "Parametre",
    "orgId": "Organisasjons Id",
    "newDTO": "Ny DTO",
    "deletedId": "Slettet Id",
    "id": "Id",
    "responseBody": "ResponseBody",
    "metadata": "Metadata",
    "privilegesDropdownError": "Kunne ikke hente rettigheter"
  },
  "keyValueTable": {
    "addNewRow": "Legg til ny rad",
    "valueLabel": "Verdi",
    "typeLabel": "Type",
    "keyLabel": "Navn",
    "noContext": "Kontekst er tom"
  }
}
